var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.00004H16.5M16.5 9.00004L14.0003 6.00004M16.5 9.00004L14.0003 12M10.5 5.25004V3.88054C10.5 3.67307 10.4569 3.46786 10.3736 3.27788C10.2902 3.08789 10.1683 2.91727 10.0157 2.77679C9.86299 2.63631 9.68283 2.52903 9.48658 2.46173C9.29033 2.39443 9.08225 2.36857 8.8755 2.38579L2.8755 2.88529C2.50054 2.91652 2.15101 3.08753 1.89622 3.3644C1.64144 3.64127 1.50002 4.00378 1.5 4.38004V13.62C1.50002 13.9963 1.64144 14.3588 1.89622 14.6357C2.15101 14.9126 2.50054 15.0836 2.8755 15.1148L8.8755 15.615C9.08232 15.6323 9.29046 15.6064 9.48676 15.539C9.68306 15.4717 9.86325 15.3643 10.0159 15.2238C10.1686 15.0832 10.2905 14.9125 10.3738 14.7224C10.4571 14.5324 10.5001 14.3271 10.5 14.1195V12.75",
    stroke: "#435869",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.cb5c9fc71fbbf2c319881fc8f8152f3a.svg";
export { ForwardRef as ReactComponent };